export const BEEFY = {
  id: 420,
  height: 5800742,
  data: {
    icon: "/imgs/icons/asset/beefy.webp",
  },
};
